import React from 'react';
import { Bell, Search, HelpCircle, Menu } from 'lucide-react';
import { Input } from '../common/Input';
import { Button } from '../common/Button';

interface HeaderProps {
  title: string;
  subtitle?: string;
  onMenuClick?: () => void;
  showMenuButton?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ 
  title, 
  subtitle, 
  onMenuClick, 
  showMenuButton = false 
}) => {
  const [searchQuery, setSearchQuery] = React.useState('');
  
  return (
    <header className="bg-black-800 border-b border-gray-700 px-3 md:px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {showMenuButton && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onMenuClick}
              icon={Menu}
              className="md:hidden"
            >
            </Button>
          )}
          <div>
            <h1 className="text-xl md:text-2xl font-bold text-white font-display">{title}</h1>
            {subtitle && (
              <p className="text-sm text-gray-400 mt-1 hidden sm:block">{subtitle}</p>
            )}
          </div>
        </div>
        
        <div className="flex items-center space-x-2 md:space-x-4">
          {/* Search */}
          <div className="hidden lg:block w-80">
            <Input
              placeholder="Search songs, artists, stores..."
              value={searchQuery}
              onChange={setSearchQuery}
              icon={Search}
              className="mb-0"
            />
          </div>
          
          {/* Mobile Search */}
          <button className="lg:hidden p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors">
            <Search className="w-5 h-5" />
          </button>
          
          {/* Notifications */}
          <button className="relative p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors">
            <Bell className="w-5 h-5" />
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-gold-500 rounded-full"></span>
          </button>
          
          {/* Help */}
          <button className="hidden sm:block p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors">
            <HelpCircle className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
};